import { useEffect } from "react";
import styles from "./LoadingOverlay.module.css";
import softindexLogo from "../../../assets/images/logo/softindex-loading-logo.webp";

export default function LoadingOverlay({ isVisible, onComplete = () => {} }) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onComplete();
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onComplete]);

  if (!isVisible) return null;

  return (
    <div className={styles.overlay} data-loading-overlay="true">
      <div className={styles.content}>
        <img
          src={softindexLogo}
          alt="Softindex"
          className={styles.logo}
          width="200"
          height="50"
        />
        <div className={styles.spinner}>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
        </div>
      </div>
    </div>
  );
}
